import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { createQueryClient } from "./data/queries";
import { router } from "./app/router";
import "./styles/index.css";
import "./styles/landing.css";
import { reportErrors } from "./data/telemetry";
import { registerServiceWorker } from "./notifications/push";
reportErrors();
// Register for installation without prompting for notifications.
if ("serviceWorker" in navigator) void registerServiceWorker().catch(() => {});
const queryClient = createQueryClient();
createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>,
);
